import '../assets/styles/pages/_about-my-rvos.scss';

export const AboutMyRvos = () => {
  return (
    <>
      <div className="about-my-rvos-page">

        <div className="main-title">
          MyRVOS
        </div>

        <div className="container">

          <div className="block_1">
            <div className="left-part">
              <div className="title">
                Manage your insurance
              </div>
              <div className="undertitle-text">
                The MyRVOS customer portal delivers convenient access to your insurance policies, billing details, and claims whenever you need it.
              </div>
              <div className="register-link">
                <a href={process.env.REACT_APP_SIGN_UP_URI} target="_blank" rel="noreferrer">
                  Register for an account
                </a>
              </div>
            </div>
            <div className="right-part">
              <img src={`${process.env.REACT_APP_MY_API_KEY}rvos-graphics/assets/img/about/my-rvos/block-1/insurance.svg`} className='insurance' alt="" />
            </div>
          </div>

          <div className="block_2">
            <div className="left-part">
              <div className="subtitle">
                Policies
              </div>
              <div className="title">
                Know your coverage
              </div>
              <div className="undertitle-text">
                The Policy section provides detailed information about your policies. You can view policy documents, coverage details, premium breakdowns, and more.
              </div>
            </div>
            <div className="right-part">
              <img src={`${process.env.REACT_APP_MY_API_KEY}rvos-graphics/assets/img/about/my-rvos/block-2/coverage.svg`} className='group' alt="" />
            </div>
          </div>

          <div className="block_3">
            <div className="text-block">
              <div className="subtitle">
                Billing
              </div>
              <div className="title">
                Easily manage your payments
              </div>
              <div className="undertitle-text">
                The Billing Center in MyRVOS allows you to manage the billing details
                of your policies and make payments, all from one convenient location.
                You can also view your account balance, upcoming payment information, past
                transaction history, and mortgagee information.
              </div>
            </div>

            <div className="img-block">
              <img src={`${process.env.REACT_APP_MY_API_KEY}rvos-graphics/assets/img/about/my-rvos/block-3/insured_pay.svg`} className='insured_pay' alt="" />
              <img src={`${process.env.REACT_APP_MY_API_KEY}rvos-graphics/assets/img/about/my-rvos/block-3/account.svg`} className='account' alt="" />
            </div>
          </div>

          <div className="block_4">
            <div className="left-part">
              <div className="subtitle">
                Claims
              </div>
              <div className="title">
                Claim management made simple
              </div>
              <div className="undertitle-text">
                Reporting a claim is a breeze in MyRVOS. You can also download claim forms, upload documents, view loss payment information, and review the details of current and past claims.
              </div>
            </div>
            <div className="right-part">
              <img src={`${process.env.REACT_APP_MY_API_KEY}rvos-graphics/assets/img/about/my-rvos/block-4/picture.svg`} className='picture' alt="" />
              <img src={`${process.env.REACT_APP_MY_API_KEY}rvos-graphics/assets/img/about/my-rvos/block-4/picture-small.svg`} className='picture-small' alt="" />
            </div>
          </div>

          <div className="block_5">
            <div className="text-block">
              <div className="subtitle">
                Communication Center
              </div>
              <div className="title">
                Get answers fast
              </div>
              <div className="undertitle-text">
                A quick and easy way to contact Сustomer Support
              </div>
            </div>

            <div className="img-block">
              <img src={`${process.env.REACT_APP_MY_API_KEY}rvos-graphics/assets/img/about/my-rvos/block-5/com.jpg`} className='com' alt="" />
            </div>
          </div>

        </div>
      </div>
    </>
  );
}
